import React from 'react'
import styled from 'styled-components'
import { Typography, Input } from 'antd'
import { Edit } from 'react-feather'

import { FlexRow } from '../FlexboxReusables/FlexItems'
import { Course } from './types'

type CourseDescriptionProps = {
  course: Course
  setCourse: (value: React.SetStateAction<Course | null>) => void
  setEditing: (value: React.SetStateAction<Record<string, boolean>>) => void
  editing: Record<string, boolean>
}

const CourseDescription: React.FC<CourseDescriptionProps> = ({ ...props }) => {
  const { course, setCourse, setEditing, editing } = props
  return (
    <FlexRow height='3em' justifyContent='flex-start' padding='10px'>
      {editing.description
        ? <Input
          height={30}
          value={course.description}
          onChange={(e) => setCourse((prevCourse) => ({
            ...prevCourse,
            description: e.target.value,
            hasUnsavedChanges: true
          }) as Course)}
          onBlur={() => setEditing({ ...editing, description: false })}
        />
        : <>
          <Typography.Text style={{ paddingBottom: '3px' }}>
            {course.description || ''}
          </Typography.Text>
          <EditIconWrapper>
            <Edit size={16} onClick={() => setEditing({ ...editing, description: true })} />
          </EditIconWrapper>
        </>
      }
    </FlexRow>
  )
}

export default CourseDescription

export const EditIconWrapper = styled.div`
  margin-left: 0.5em;
  padding-bottom: 0.3em;
  cursor: pointer;
`